import React from "react";
import { SharedAddressInput } from "../common/SharedAddressInput";
import { ComplianceCountrySelect } from "./ComplianceCountrySelect";
import { type AddressInputProps } from "./types";

/**
 * AddressInput component represents an input form for capturing address information.
 *
 * @component
 * @example
 * ```tsx
 * <AddressInput
 *   title="Billing Address"
 *   description="Enter your billing address"
 *   onCountryChange={handleCountryChange}
 * />
 * ```
 *
 * @param {AddressInputProps} props - The props for the AddressInput component.
 * @param {string} props.title - The title of the address input form.
 * @param {string} props.description - The description of the address input form.
 * @param {Function} props.onCountryChange - The callback function to handle country change.
 * @param {boolean} props.includeSameAsMailingAddressField - Flag to enable the same as mailing address field.
 * @returns {React.FC<AddressInputProps>} The AddressInput component.
 *
 * @todo Ideally a significant amount of validation would occur on this form to ensure good data.
 */
export const AddressInput: React.FC<AddressInputProps> = ({
  title,
  description,
  onCountryChange = undefined,
}: AddressInputProps) => {
  return (
    <SharedAddressInput
      title={title}
      description={description}
      CountrySelect={ComplianceCountrySelect}
      onCountryChange={onCountryChange}
    />
  );
};
